import { t, Trans } from '@lingui/macro';
import { I18n } from '@lingui/react';
import log from 'loglevel';
import PropTypes from 'prop-types';
import React from 'react';
import '../UserInfoForm/UserInfoForm.styles';
import * as Styles from '../UserInfoForm/UserInfoForm.styles.js';

/**
 * Log errors
 *
 * @param { string } error message
 * @param { string } info message
 *
 * @returns { object } error message
 */
const sendToErrorReporting = (error, info) => {
  log.error(error);
  log.error(info);
};

class ErrorBoundary extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
    };
  }

  componentDidCatch(error, info) {
    this.setState((state) => ({
      ...state,
      hasError: true,
    }));
    sendToErrorReporting(error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <Styles.StyledWrapper>
          <Styles.StyledForm>
            <Styles.StyledH1>
              <Trans>Request a call</Trans>
            </Styles.StyledH1>
            <Styles.StyledErrorNotice>
              <div id='unavailable'>
                <I18n>
                  {({ i18n }) => (
                    i18n._(t`Service is unavailable at the moment. Please try again later.`)
                  )}
                </I18n>
              </div>
            </Styles.StyledErrorNotice>
          </Styles.StyledForm>
        </Styles.StyledWrapper>
      );
    } else {
      return this.props.children;
    }
  }
}

export default ErrorBoundary;

ErrorBoundary.propTypes = {
  children: PropTypes.object,
};
